/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { useLocation, useHistory } from 'react-router-dom';
import { Steps } from 'primereact/steps';
import { ProgressSpinner } from 'primereact/progressspinner';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import { itemsDocumento } from '../cadastrar-contratos/opcoesDropdown';
import UploadTrocaContrato from '../uploadTrocaContrato';
import UploadTrocaContratoContaDeLuz from '../uploadTrocaContratoContaDeLuz';
import UploadContratoContaDeLuz from '../uploadContratoContaDeLuz';
import './styles.css';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import UploadComprovanteResidencia from '../uploadComprovanteResidencia';

const CadastrarDocumentos = () => {
    const header = <img alt="Card Header" src={FundoAmarelo} />;
    const history = useHistory();
    const link = useLocation();
    const inscricao = link.pathname.split('/')[2];
    const [loading, setLoading] = useState(true);
    const [contrato, setContrato] = useState({});
    const tipoCobranca = contrato.tipoCobranca;
    const tipoVenda = contrato.tipoVenda;
    const dadosUltimoContratoCadastrado =
        decriptObjectOnLocalStorage('dadosUltimoContrato');

    const tipoUpload = () => {
        if (tipoVenda === 'TROCA') {
            if (tipoCobranca === 8) {
                return <UploadTrocaContratoContaDeLuz inscricao={inscricao} />;
            } else {
                return <UploadTrocaContrato inscricao={inscricao} />;
            }
        } else if (tipoVenda !== 'TROCA') {
            if (tipoCobranca === 8) {
                return <UploadContratoContaDeLuz inscricao={inscricao} />;
            } else {
                return <UploadComprovanteResidencia inscricao={inscricao} />;
            }
        }

        return history.push('/');
    };

    useEffect(() => {
        if (dadosUltimoContratoCadastrado) {
            setTimeout(() => {
                setContrato(dadosUltimoContratoCadastrado);
                setLoading(false);
            }, 2000);
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <Card className='tratar-scroll-card' header={header} title="Upload de Arquivos">
            <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                <Steps model={itemsDocumento} activeIndex={1} />
            </div>
            {loading ? (
                <div className="loading-container">
                    <ProgressSpinner
                        style={{ width: '250px',
                            height: '150px' }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration="0.5s"
                    />
                </div>
            ) : (
                tipoUpload()
            )}
        </Card>
    );
};

export default CadastrarDocumentos;
